/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";

interface Props {
	total: number;
	passed: number;
	failed: number;
	allAssessed: boolean;
	toggleConfirmationModal: () => void;
	toggleRecleanModal: () => void;
}
const PACleaningFooter = ({
	total,
	passed,
	failed,
	allAssessed,
	toggleRecleanModal,
	toggleConfirmationModal,

}: Props) => {
	const { t } = useTranslation();
	return (
		<div className="fixed bottom-0 left-64 right-0 bg-white px-10 py-4 border-t border-slate-200 flex justify-between items-center shrink-0 shadow-[0_-4px_20px_rgba(0,0,0,0.03)]">
			<div className="flex items-center gap-4">
				<div className="flex -space-x-2">
					{[1, 2, 3].map((i) => (
						<div
							key={i}
							className="w-8 h-8 rounded-full border-2 border-white bg-slate-100 flex items-center justify-center text-[10px] font-black text-slate-400"
						>
							{String.fromCharCode(64 + i)}
						</div>
					))}
				</div>
				<div className="h-8 w-px bg-slate-200 mx-2"></div>
				<div className="flex items-center gap-2 text-emerald-600">
					<span className="material-symbols-outlined text-xl">
						verified
					</span>
					<span className="text-xs font-black uppercase tracking-[0.15em]">
						{passed + failed} / {total} {t("postAutoclaveProcess.mediaCleaning.platesAssessed")}
					</span>
				</div>
			</div>

			<div className="flex gap-4 items-center">
				{!allAssessed && (
					<div className="flex items-center gap-2 text-orange-500 bg-orange-50 px-4 py-2 rounded-xl border border-orange-100 animate-pulse">
						<span className="material-symbols-outlined text-lg">
							info
						</span>
						<span className="text-[10px] font-black uppercase tracking-widest">
							{t("postAutoclaveProcess.mediaCleaning.allPlatesMustbeAssessed")}
						</span>
					</div>
				)}
				{/* <button className="px-8 py-3.5 border border-slate-200 rounded-2xl text-[11px] font-black text-slate-500 uppercase tracking-widest hover:bg-slate-50 hover:text-slate-800 transition-all">
					{t("postAutoclaveProcess.mediaCleaning.back")}
				</button> */}
				<button
					disabled={failed === 0}
					onClick={() => toggleRecleanModal()}
					className="px-8.5 py-2.5 bg-orange-500 text-white rounded-xl text-[11px] font-black uppercase tracking-widest shadow-lg shadow-orange-100 hover:bg-orange-600 transition-all flex items-center gap-2.5 disabled:opacity-30 disabled:grayscale disabled:cursor-not-allowed border-none"
				>
					<span className="material-symbols-outlined text-lg">
						refresh
					</span>
					{t("postAutoclaveProcess.mediaCleaning.sendFailedPlatesForReClean", {failed})}
				</button>
				<button
					onClick={() => toggleConfirmationModal()}
					className="px-9 py-2.5 bg-[#2D3E50] text-white rounded-xl text-[11px] font-black uppercase tracking-widest shadow-xl shadow-slate-200 hover:bg-slate-800 transition-all flex items-center gap-2.5 disabled:opacity-30 disabled:grayscale disabled:cursor-not-allowed"
				>
					{t("postAutoclaveProcess.mediaCleaning.save&Continue")}
					<span className="material-symbols-outlined text-lg">
						arrow_forward
					</span>
				</button>
			</div>
		</div>
	);
};

export default PACleaningFooter;
